import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ModalService } from 'src/app/services/modal.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { PersistenceService } from 'src/app/services/persistence.service';
import { ContactusComponent } from '../../contactus/contactus.component';
import { EnsureDeclineComponent } from '../../ensure-decline/ensure-decline.component';

@Component({
    selector: 'app-initial-login',
    templateUrl: './initial-login.component.html',
    styleUrl: './initial-login.component.scss',
    standalone: false
})
export class InitialLoginComponent {
  isSubmitting = false;
  isFormCompleted = false;
  loginID;
  regcode;
  errorMsg;

  constructor(
    private authenticationService:AuthenticationService,
    private navigationService: NavigationService,
    private persistenceService: PersistenceService,
    private modalService: ModalService,
    private router: Router,
    public dialog: MatDialog,
  ){
  }

  forward(){
    if(!this.isSubmitting){
      this.isFormCompleted = true;
      this.isSubmitting = true;
      const creds: any = {};
      if (this.loginID) {
        creds.username = this.loginID;
        creds.password = 'password';
        this.authenticationService.initialLogin(creds, this.regcode).then(() => {
          // promise resolved
          if(this.regcode){
            this.authenticationService.mapRegCode(this.regcode);
          }
          this.navigationService.forward();
        }, (err) => {
          this.isSubmitting =false;
          this.errorMsg = err;
        });
      } else {
        this.isSubmitting =false;
        this.errorMsg = 'Please enter a Login ID';
      }
    }
  }
  declineButtonClick() {

    this.persistenceService.testStorage();
    this.persistenceService.clear();

    const creds: any = {};
    console.log(this.loginID);
    creds.username = this.loginID;
    creds.password = 'password';

    if (this.loginID) {
      this.authenticationService.initialLogin(creds, this.regcode).then(() => {

        this.authenticationService.verifyForDecline().subscribe({
          next:()=>{
            //console.log("dec ok");
            this.errorMsg = undefined;
            this.openDeclineDialog();
          },
          error: err=>{
            //console.log("Err: ", err);
            this.errorMsg = 'Please enter a valid Login ID!!';
          }
        });

      }, (err) => {
        this.errorMsg = err;
      });
    }else {
      this.isSubmitting =false;
      this.errorMsg = 'Please enter a Login ID';
    }

  }

  openModal(copy, title, actionButtonText) {
    this.modalService.openModal(copy, title, actionButtonText);
  }

  openDeclineDialog(){
    const dialogRef = this.dialog.open(EnsureDeclineComponent, {
      disableClose: true,
      data: { row: null }
    });
    
    dialogRef.afterClosed().subscribe(result => {
      if(result==1){
        this.authenticationService.updateProfile('CANCELLED', "Declined from Login Page").subscribe(() => {
          this.router.navigate(['decline']);
        });
      }
    });
  }
}
